export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/brand-union.c3c31183.svg","height":16,"width":25,"blurWidth":0,"blurHeight":0};